const u = (id, w = 1200) =>
    `https://images.unsplash.com/${id}?auto=format&fit=crop&q=80&w=${w}`;

export const IMG = {
    hero: u("photo-1585937421612-70a008356fbe", 1600),
    butterChicken: u("photo-1603894584373-5ac82b2ae398", 900),
    tikkaMasala: u("photo-1565557623262-b51c2513a641", 900),
    paneer: u("photo-1631452180519-c014fe946bc7", 900),
    dal: u("photo-1547592166-23ac45744acd", 900),
    biryani: u("photo-1589302168068-964664d93dc0", 900),
    tandoori: u("photo-1599487488170-d11ec9c172f0", 900),
    thali: u("photo-1596797038530-2c107229654b", 1200),
    spices: u("photo-1596040033229-a9821ebd058d", 900),
    samosa: u("photo-1601050690597-df0568f70950", 900),
    curryBread: u("photo-1567337710282-00832b415979", 900),
    plating: u("photo-1546833999-b9f581a1996d", 900),
    interior1: u("photo-1552566626-52f8b828add9", 1000),
    interior2: u("photo-1414235077428-338989a2e8c0", 1000),
    interior3: u("photo-1517248135467-4c7edcad34c4", 1000),
};

const f = (id) => u(id, 800);

// Verified dish photography pool — every entry checked live + visually relevant
export const FOOD = {
    samosaPlate: f("photo-1601050690117-94f5f6fa8bd7"),
    samosa: f("photo-1601050690597-df0568f70950"),
    skewers: f("photo-1599487488170-d11ec9c172f0"),
    skewersFries: f("photo-1603360946369-dc9bb6258143"),
    mixedGrill: f("photo-1555939594-58d7cb561ad1"),
    tandooriChicken: f("photo-1610057099443-fde8c4d50f91"),
    tandooriLegs: f("photo-1626074353765-517a681e40be"),
    chickenTikkaPlate: f("photo-1604908176997-125f25cc6f3d"),
    fishCurry: f("photo-1574484284002-952d92456975"),
    chaat: f("photo-1610192244261-3f33de3f55e4"),
    thaliTray: f("photo-1626777552726-4a6b54c97e46"),
    soupTomato: f("photo-1547592166-23ac45744acd"),
    soupCream: f("photo-1604152135912-04a022e23696"),
    soupOrange: f("photo-1548943487-a2e4e43b4853"),
    saladBowl: f("photo-1512621776951-a57141f2eefd"),
    saladPlate: f("photo-1540189549336-e6e99c3679fe"),
    raita: f("photo-1633383718081-22ac93e3db65"),
    butterChicken: f("photo-1603894584373-5ac82b2ae398"),
    tikkaMasala: f("photo-1565557623262-b51c2513a641"),
    paneerMasala: f("photo-1631452180519-c014fe946bc7"),
    paneerRice: f("photo-1588166524941-3bf61a9c41db"),
    palakPaneer: f("photo-1589647363585-f4a7d3877b10"),
    curryHero: f("photo-1585937421612-70a008356fbe"),
    curryBread: f("photo-1567337710282-00832b415979"),
    curryPan: f("photo-1596797038530-2c107229654b"),
    thaliParatha: f("photo-1546833999-b9f581a1996d"),
    chickenPot: f("photo-1574653853027-5382a3d23a15"),
    chickenPan: f("photo-1631292784640-2b24be784d5d"),
    lambCurry: f("photo-1545247181-516773cae754"),
    kofta: f("photo-1534422298391-e4f8c172dddb"),
    biryani: f("photo-1589302168068-964664d93dc0"),
    biryaniClay: f("photo-1642821373181-696a54913e93"),
    biryaniChicken: f("photo-1631515243349-e0cb75fb8d3a"),
    biryaniLamb: f("photo-1633945274405-b6c8069047b0"),
    biryaniBowls: f("photo-1563379091339-03b21ab4a4f8"),
    riceVeg: f("photo-1596560548464-f010549b84d7"),
    friedRice: f("photo-1603133872878-684f208fb84b"),
    noodles: f("photo-1585032226651-759b368d7246"),
    noodlesChop: f("photo-1612929633738-8fe44f7ec841"),
    naanBasket: f("photo-1617692855027-33b14f061079"),
    rollsCurry: f("photo-1606491956689-2ea866880c84"),
    gulabJamun: f("photo-1666190092159-3171cf0fbb12"),
    dessertCaramel: f("photo-1551024506-0bccd828d307"),
    kulfi: f("photo-1497034825429-c343d7c6a68f"),
    mangoLassi: f("photo-1623065422902-30a2d299bbe4"),
    lassiPink: f("photo-1553530666-ba11a7da3888"),
    chai: f("photo-1571934811356-5cc061b6821f"),
    coffee: f("photo-1509042239860-f550ce710b93"),
    softDrink: f("photo-1554866585-cd94860890b7"),
    water: f("photo-1548839140-29a749e1cf4d"),
    spices: f("photo-1596040033229-a9821ebd058d"),
};

export const dishImg = (dish, w) => {
    const url = FOOD[dish.img] || FOOD.spices;
    return w ? url.replace("w=800", `w=${w}`) : url;
};
